import { render, staticRenderFns } from "./RegionSwitcher.vue?vue&type=template&id=4c39cbd9&scoped=true&"
import script from "./RegionSwitcher.vue?vue&type=script&lang=js&"
export * from "./RegionSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./RegionSwitcher.vue?vue&type=style&index=0&id=4c39cbd9&lang=scss&scoped=true&"
import style1 from "./RegionSwitcher.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c39cbd9",
  null
  
)

export default component.exports